// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { put, call, takeEvery } from 'redux-saga/effects';

import { howItWorksService } from './service';
import * as howItWorksActions from './actions';
import * as types from './actionTypes';

function* howItWorksSaga() {
  const res = yield call(howItWorksService);
  if (res.ok) {
    const result = res.body.items[0];
    const {
      title,
      description_paragraph1,
      description_paragraph2,
      gallery_image_picker,
    } = result;
    const imagesWithDescription = gallery_image_picker.map((el) => {
      const image = el.image.meta.download_url;
      return {
        image: `${image}`,
        title: el.title,
        description: el.description,
      };
    });
    yield put(howItWorksActions.requestPageDataSuccess({
      title,
      description_paragraph1: description_paragraph1
        .substring(3, description_paragraph1.length - 4),
      description_paragraph2: description_paragraph2
        .substring(3, description_paragraph2.length - 4),
      imagesWithDescription,
    }));
  }
}

const howItWorksSagas = [
  takeEvery(types.HIW_REQUEST_PAGE_DATA, howItWorksSaga),
];

export default howItWorksSagas;
